import Div from "theme/layouts/Div";
import PropTypes from "prop-types";
import React from "react";
import TextStyles from "theme/components/text/TextStyles";
import Wysiwyg from "theme/libs/wordpress/components/Wysiwyg";
import variables from "theme/config/variables";

const SubHeading = ({ data }) => (
    <Div
        position="relative"
        mb={data.type === "h2" ? ["16px", null, null, null, "24px"] : ["8px", null, null, null, "16px"]}
    >
        {/* We place the anchor_link above the actual content, otherwise the content will go behind the header bar when scrolled to. */}
        {data?.anchor_link && (
            <Div
                id={data?.anchor_link}
                position="absolute"
                top={[
                    `calc(-${variables.headerHeightMobile}px - 16px)`,
                    null,
                    null,
                    null,
                    `calc(-${variables.headerHeightDesktop}px - 24px)`,
                ]}
            />
        )}
        <Wysiwyg
            data={data.text}
            textComponent={(props) => (
                <TextStyles
                    as={data.type === "default" ? "h2" : data.type}
                    textStyles={
                        data.type === "default" || data.type === "h2"
                            ? ["Myriad Pro/24-120-semibold", null, null, null, "Myriad Pro/32-120-semibold"]
                            : [
                                  "Myriad Pro/18-100-semibold-semiextended",
                                  null,
                                  null,
                                  null,
                                  "Myriad Pro/20-100-semibold",
                              ]
                    }
                    {...props}
                />
            )}
        />
    </Div>
);

SubHeading.propTypes = {
    data: PropTypes.object,
};

SubHeading.defaultProps = {
    data: {},
};

export default SubHeading;
